import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useI18n } from "@/context/I18nContext";
import { SectionHead } from "@/components/landing/HowItWorks";
import { stickerSrc } from "@/components/landing/data";

export const Faq = () => {
  const { t } = useI18n();
  return (
    <section id="faq" className="py-24 scroll-mt-20" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <SectionHead label={t("ld.faq_label")} title={t("ld.faq_title")} />
        <Accordion type="single" collapsible className="space-y-3">
          {[0, 1, 2, 3, 4].map((i) => (
            <AccordionItem key={i} value={`q${i}`} className="cx-card rounded-xl px-5 border-none" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left text-white font-medium hover:no-underline">{t(`ld.q${i}`)}</AccordionTrigger>
              <AccordionContent className="text-slate-400 leading-relaxed">{t(`ld.a${i}`)}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export const FinalCta = () => {
  const { t } = useI18n();
  return (
    <section className="py-24" data-testid="final-cta-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-[#0b0e1a] px-8 sm:px-14 py-16">
          <div className="absolute inset-0 cx-grid-bg opacity-40" />
          <img src={stickerSrc("victory")} alt="" className="absolute right-6 sm:right-14 top-1/4 w-44 sm:w-64 cx-float opacity-90 hidden sm:block" style={{ "--r": "6deg" }} />
          <div className="relative max-w-xl">
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-white leading-tight">{t("ld.final_title")}</h2>
            <Link to="/login?mode=register" data-testid="final-cta-btn" className="group inline-flex mt-8 cx-btn rounded-full px-7 py-3.5 font-semibold items-center gap-2">
              {t("ld.final_cta")}<ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
